// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    reports_list_datasets: 'Mirando qué se puede medir',
    reports_describe_dataset: 'Leyendo qué contiene un conjunto de datos',
    reports_run_query: 'Calculando las cifras',
    reports_analyse_metric: 'Leyendo la forma de una cifra',
    reports_find_insights: 'Mirando lo que se ha señalado',
    reports_entity_report: 'Reuniendo todo sobre uno de ellos',
    reports_save_report: 'Guardando el informe',
    reports_schedule_report: 'Programando el informe',
  },
  ca: {
    reports_list_datasets: 'Mirant què es pot mesurar',
    reports_describe_dataset: 'Llegint què conté un conjunt de dades',
    reports_run_query: 'Calculant les xifres',
    reports_analyse_metric: 'Llegint la forma d’una xifra',
    reports_find_insights: 'Mirant el que s’ha assenyalat',
    reports_entity_report: 'Reunint-ho tot sobre un d’ells',
    reports_save_report: 'Desant l’informe',
    reports_schedule_report: 'Programant l’informe',
  },
  en: {
    reports_list_datasets: 'Looking at what can be measured',
    reports_describe_dataset: 'Reading what a dataset holds',
    reports_run_query: 'Working out the figures',
    reports_analyse_metric: 'Reading the shape of a figure',
    reports_find_insights: 'Checking what has been flagged',
    reports_entity_report: 'Gathering everything about one of them',
    reports_save_report: 'Saving the report',
    reports_schedule_report: 'Putting the report on a schedule',
  },
  fr: {
    reports_list_datasets: 'Ce qu’on peut mesurer',
    reports_describe_dataset: 'Lecture du contenu d’un jeu de données',
    reports_run_query: 'Calcul des chiffres',
    reports_analyse_metric: 'Lecture de l’allure d’un chiffre',
    reports_find_insights: 'Ce qui a été signalé',
    reports_entity_report: 'Rassemblement de tout sur l’un d’eux',
    reports_save_report: 'Enregistrement du rapport',
    reports_schedule_report: 'Planification du rapport',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
